import React from 'react'

import iconMap from '../../assets/icons/icon-map'

import { Box } from '../Box/Box'
import { Icon } from '../Icon/Icon'
import { Stack } from '../Stack/Stack'
import { Inline } from '../Inline/Inline'
import { Text } from '../Text/Text'

export interface FieldLabelProps {
  label: string
  labelWeight?: 'regular' | 'strong' | 'stronger'
  secondary?: string
  tertiary?: string
  tertiaryIcon?: keyof typeof iconMap
  tertiaryAction?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  description?: string
}

export const FieldLabel: React.FC<FieldLabelProps> = ({
  label,
  labelWeight = 'strong',
  secondary,
  tertiary,
  tertiaryIcon,
  tertiaryAction,
  description
}) => {
  return (
    <Stack space="xs">
      <Box display="flex" alignItems="center" justifyContent="between" width="100%" height="auto">
        <Inline space="xxs" alignY="center">
          <Text weight={labelWeight} size="base">
            {label}
          </Text>

          {secondary && <Text tone="light">{`(${secondary})`}</Text>}
        </Inline>

        {(tertiary || tertiaryIcon) && (
          <Box
            component="button"
            display="flex"
            alignItems="center"
            background="none"
            border="none"
            onClick={tertiaryAction}
            cursor="pointer"
            style={{
              color: 'var(--colors-action)',
              outline: 'none'
            }}
          >
            <Inline space="xxs" alignY="center">
              {tertiaryIcon && (
                <Box display="flex" alignItems="center">
                  <Icon name={tertiaryIcon} size="s" tone="action" />
                </Box>
              )}
              <Text tone="action">{tertiary}</Text>
            </Inline>
          </Box>
        )}
      </Box>

      {description && (
        <Box>
          <Text component="p" pLineHeight={1.2} tone="light" size="small">
            {description}
          </Text>
        </Box>
      )}
    </Stack>
  )
}
